import { render, staticRenderFns } from "./storage_info_selector.vue?vue&type=template&id=49f3cbc4"
import script from "./storage_info_selector.vue?vue&type=script&lang=js"
export * from "./storage_info_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports